module.exports = __webpack_public_path__ + "static/media/29FUNOV2.95738419.jpg";